const common = {
  en: {
    shared: {
      loading: "Loading...",
      noData: "No data available",
      back: "Back",
      export: "Export",
      refresh: "Refresh"
    }
  },
  fr: {
    shared: {
      loading: "Chargement...",
      noData: "Aucune donnée disponible",
      back: "Retour",
      export: "Exporter",
      refresh: "Actualiser"
    }
  }
};

export default common;
